import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Endpoints, Mutations } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'TemplateRenderer', namespaced: true})
export default class TemplateRenderer extends VuexModule {
    public templateRendererOverlayVisibility: boolean = false;
    public templateRenderer: any = '';

    @Mutation
    public RESET_TEMPLATE_RENDERER_STORE_STATE() {
        this.templateRendererOverlayVisibility = false;
        this.templateRenderer                  = '';
    }

    get getTemplateRendererOverlayVisibility(): boolean {
        return this.templateRendererOverlayVisibility;
    }

    get getTemplateRenderer(): any {
        return this.templateRenderer;
    }

    @Action
    public FETCH_TEMPLATE_RENDERER(data: any) {
        axios.post(Endpoints.Admin.Templates.TEMPLATE_RENDERER(data.templateId), data)
            .then((response: any) => {
                store.commit(Mutations.SET_TEMPLATE_RENDERER, response.data);
                store.commit(Mutations.TEMPLATE_RENDERER_OVERLAY_VISIBILITY, true);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_TEMPLATE_RENDERER(data: any): void {
        this.templateRenderer = data;
    }

    @Mutation
    public TEMPLATE_RENDERER_OVERLAY_VISIBILITY(visibility: boolean): void {
        this.templateRendererOverlayVisibility = visibility;
    }
}
